import { CountryFlag } from 'shared/src/CountryFlag';

export function FormattedProduct({
  countryIso,
  label
}: {
  countryIso: string;
  label: string;
}): JSX.Element {
  return (
    <div
      className="flex flex-row items-center gap-4"
      data-testid="product-selector"
    >
      <CountryFlag className="!size-[22px]" countryCode={countryIso} svg />
      <p>{label}</p>
    </div>
  );
}
